import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import {getHistory} from 'src/modules/history';
import {i18n} from 'src/i18n';

const prefix = 'EMPLOYEE_CATEGORY_FORM';

const employeeCategoryFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,
  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,
  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({type: employeeCategoryFormActions.INIT_STARTED});
      let record = {};
      if (Boolean(id)) {
        record = await EmployeeCategoryService.find(id);
      }
      dispatch({type: employeeCategoryFormActions.INIT_SUCCESS, payload: record});
    } catch (error) {
      Errors.handle(error);
      dispatch({type: employeeCategoryFormActions.INIT_ERROR});
      getHistory().push('/employee-category');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({type: employeeCategoryFormActions.CREATE_STARTED});
      await EmployeeCategoryService.create(values);
      dispatch({type: employeeCategoryFormActions.CREATE_SUCCESS});
      Message.success(i18n('entities.employeeCategory.create.success'));
      getHistory().push('/employee-category');
    } catch (error) {
      Errors.handle(error);
      dispatch({type: employeeCategoryFormActions.CREATE_ERROR});
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({type: employeeCategoryFormActions.UPDATE_STARTED});
      await EmployeeCategoryService.update(id, values);
      dispatch({type: employeeCategoryFormActions.UPDATE_SUCCESS});
      Message.success(i18n('entities.employeeCategory.update.success'));
      getHistory().push('/employee-category');
    } catch (error) {
      Errors.handle(error);
      dispatch({type: employeeCategoryFormActions.UPDATE_ERROR});
    }
  },
};

export default employeeCategoryFormActions;
